module.exports = __webpack_public_path__ + "img/economic_value_splash.201309c9.jpg";